/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export const CYBERSOURCE_ROUTES = {
    applePayConfig: '/resource/cybersource-apple-pay-config',
    applePayMerchantSession: '/action/cybersource-apple-pay-merchant-session',
    applePayShipping: '/action/cybersource-apple-pay-shipping',
    applePayComplete: '/action/cybersource-apple-pay-complete',
    applePayRestoreBasket: '/action/cybersource-apple-pay-restore-basket',
    paypalApproved: '/cybersource-paypal-approved',
    paypalCancelled: '/cybersource-paypal-cancelled',
    captureContext: '/resource/cybersource-capture-context',
    paypalInitiate: '/resource/cybersource-paypal-initiate',
    paypalReturn: '/resource/cybersource-paypal-return',
} as const;
